import styled from 'styled-components';
import { fontColor } from 'Public/Css/colors';

export default styled.div `

    min-height: 30px;

    input.ant-input {
        height: 30px;
    }

    textarea.ant-input {
        min-height: 80px;
    }
    
    input, textarea {
        border: solid 1px ${ fontColor };
        //border-radius: 4px;
        font-size: 16px;
        padding-top: 11px;
        padding-bottom: 10px;
        //min-height: 40px !important;
    }
    
    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active  {
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }

    .ant-input-number {
        border: solid 1px ${ fontColor };
      
        input {
            border: none;
        }    
    }
  
    .ant-input-number-sm input {
        min-height: auto !important;
    }

    .ant-input-number-input {
        text-align: right;
        padding-right: 40px;
    }
  
`;
